var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{style:(_vm.style)},[_c('vue-core-video-player',{ref:"core_video_player",staticClass:"video-player",attrs:{"src":_vm.src,"volume":_vm.volume,"muted":_vm.muted,"controls":_vm.controls,"autoplay":_vm.autoplay},on:{"error":function($event){return _vm.errorHandler()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }